import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import TabNavItem from '../common/tabs/TabNavItem';
import TabContent from '../common/tabs/TabContent';
import EmailProcessTable from './EmailProcessTable';
import SmsProcessTable from './SmsProcessTable';
import QueueTabPlaceholder from './QueueTabPlaceholder';

function ProcessTabContainer() {
    const [activeTab, setActiveTab] = useState('email-tab');
    const [searchPanelOpen, setSearchPanelOpen] = useState(false);

    return (
        <Card className="card-padding shadow-sm border-0">
            <Card.Body className="p-3">
                <div className="d-flex align-items-end justify-content-between gap-2 mb-3 nav-tabs-bordered">
                    <ul className="nav nav-tabs flex-grow-1 mb-0 border-0">
                        <TabNavItem
                            id="email-tab"
                            title="Email Queue"
                            icon="bi bi-envelope"
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                        <TabNavItem
                            id="sms-tab"
                            title="SMS Queue"
                            icon="bi bi-chat-dots"
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                        <TabNavItem
                            id="call-tab"
                            title="Call Queue"
                            icon="bi bi-telephone"
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                    </ul>
                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm flex-shrink-0"
                        onClick={() => setSearchPanelOpen((open) => !open)}
                        aria-expanded={searchPanelOpen}
                        title={searchPanelOpen ? 'Hide filters' : 'Show filters'}
                    >
                        <i className="bi bi-funnel me-1"></i>
                        Filter
                    </button>
                </div>
                <div className="tab-content">
                    <TabContent id="email-tab" activeTab={activeTab}>
                        <EmailProcessTable searchPanelOpen={searchPanelOpen} />
                    </TabContent>
                    <TabContent id="sms-tab" activeTab={activeTab}>
                        <SmsProcessTable searchPanelOpen={searchPanelOpen} />
                    </TabContent>
                    <TabContent id="call-tab" activeTab={activeTab}>
                        <QueueTabPlaceholder queueType="Call" />
                    </TabContent>
                </div>
            </Card.Body>
        </Card>
    );
}

export default ProcessTabContainer;
